import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { InvitePage } from './pages/InvitePage';
import { PortalLayout } from './portal/PortalLayout';
import { OverviewScreen } from './portal/screens/OverviewScreen';
import { ClientsScreen } from './portal/screens/ClientsScreen';
import { ClientDetailScreen } from './portal/screens/ClientDetailScreen';
import { SessionsScreen } from './portal/screens/SessionsScreen';
import { LibraryScreen } from './portal/screens/LibraryScreen';
import { OrdersScreen } from './portal/screens/OrdersScreen';
import { SettingsScreen } from './portal/screens/SettingsScreen';
import { UsersPage } from './pages/admin/UsersPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {/* Public: an invited client has no account yet. */}
          <Route path="/invite" element={<InvitePage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <PortalLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<OverviewScreen />} />
            {/* Practitioner-only: the API scopes clients to a practitioner, so a
                client-role user would otherwise land on a screen that 403s.
                Admins pass every roles check by the superset rule. */}
            <Route
              path="clients"
              element={
                <ProtectedRoute roles={['practitioner']}>
                  <ClientsScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path="clients/:id"
              element={
                <ProtectedRoute roles={['practitioner']}>
                  <ClientDetailScreen />
                </ProtectedRoute>
              }
            />
            {/* Deliberately ungated: clients book here, practitioners monitor,
                admins pass by the superset rule. The API scopes rows per role. */}
            <Route path="sessions" element={<SessionsScreen />} />
            {/* Also deliberately ungated: clients browse and play here; the API
                shapes the payload per role (managers get drafts + admin fields). */}
            <Route path="library" element={<LibraryScreen />} />
            {/* Store operations: lists other buyers' emails — never client-visible. */}
            <Route
              path="orders"
              element={
                <ProtectedRoute roles={['practitioner']}>
                  <OrdersScreen />
                </ProtectedRoute>
              }
            />
            <Route path="settings" element={<SettingsScreen />} />
            <Route
              path="admin/users"
              element={
                <ProtectedRoute roles={['admin']}>
                  <UsersPage />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
